import { useAuth } from '@/contexts/AuthContext';
import { SplashLoader } from '@/components/SplashLoader';
import { logDebug } from '@/utils/errorHandler';

interface AdminOnlyProps {
  children: React.ReactNode;
}

export default function AdminOnly({ children }: AdminOnlyProps) {
  const { user, loading } = useAuth();
  logDebug('AdminOnly authentication check', {
    user: user ? { id: user.id, is_staff: user.is_staff, email: user.email } : null,
    loading,
    hasUser: !!user,
    isStaff: user?.is_staff || false,
  });
  if (loading) return <SplashLoader />;
  if (!user?.is_staff) return null;
  return <>{children}</>;
}
